import { Button } from '@/components/Button';
import PnlShareCard from '@/components/Card/PnlShareCard';
import Checkbox from '@/components/Checkbox';
import CopySrc from '../asset/copy_icon.svg?url';
import DownloadSrc from '../asset/download_icon.svg?url';
import LinkSrc from '../asset/tweet_icon.svg?url';
import './index.less';

import { Tooltip } from 'antd';

import { useMediaQueryDevice } from '@/components/MediaQuery';
import classNames from 'classnames';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import usePnlSharePanel, { optionInfos } from '../../../../hooks/trade/usePnlSharePanel';

export default function PnlShareModalContent({ pnlStorageKey }: { pnlStorageKey: string }) {
  const cardRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();
  const { isMobile, deviceType } = useMediaQueryDevice();
  const {
    handleClickDownload,
    handleCopy,
    toggleOption,
    optionStatus,
    handleTweet,
    btnStatus,
    btnMessage,
  } = usePnlSharePanel({ cardRef, storageKey: pnlStorageKey });
  return (
    <div className={classNames('syn-psmc', deviceType)}>
      <PnlShareCard optionStatus={optionStatus} />
      {/* // This is for export image */}
      <div ref={cardRef} style={{ position: 'absolute', top: -1000000, display: 'flex' }}>
        <PnlShareCard optionStatus={optionStatus} isExport />
      </div>
      <div className="syn-psmc-panel">
        <div className="syn-psmc-panel-title">{t('common.pnlShareModal.optionShare')}</div>
        <div className="syn-psmc-panel-options">
          {optionInfos.map((info) => (
            <div key={info.optionId} className="syn-psmc-panel-option">
              <Checkbox
                checked={optionStatus[info.optionId]}
                onChange={() => {
                  toggleOption(info.optionId);
                }}>
                <span>{t(info.i18nId)}</span>
              </Checkbox>
            </div>
          ))}
        </div>
        <div className={classNames('syn-psmc-panel-btns', isMobile && 'syn-psmc-panel-btns-mobile-3')}>
          <Tooltip title={btnMessage.copy} open={btnMessage.copy !== null} overlayStyle={{ zIndex: 10000 }}>
            <Button
              loading={btnStatus.copy === 'loading'}
              onClick={() => handleCopy()}
              id="copy"
              type="primary"
              suffixNode={<img src={CopySrc} />}>
              {t('common.pnlShareModal.copy')}
            </Button>
          </Tooltip>

          <Tooltip title={btnMessage.download} open={btnMessage.download !== null} overlayStyle={{ zIndex: 10000 }}>
            <Button
              loading={btnStatus.download === 'loading'}
              id="download"
              onClick={() => handleClickDownload()}
              type="primary"
              suffixNode={<img src={DownloadSrc} />}>
              {t('common.download')}
            </Button>
          </Tooltip>

          <Tooltip title={btnMessage.tweet} open={btnMessage.tweet !== null} overlayStyle={{ zIndex: 10000 }}>
            <Button
              loading={btnStatus.tweet === 'loading'}
              onClick={() => handleTweet()}
              id="tweet"
              type="primary"
              suffixNode={<img src={LinkSrc} />}>
              {t('common.tweet')}
            </Button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
}
